export default __webpack_public_path__ + "static/mp-5d8a5a16c93ee7a143dcbe184258e622.svg";